import React from 'react';

const PolicyNav = ({ model, onNavClick, selectedSection }) => {

    var isAnnuity = false;
    var isHealth = false;
    var isMS = false;
    var isLife = false;
    var isFIA = false;
    var hasAllocations = false;
    var isSuppConn = false;
    var isUnknown = false;

    var hasServiceForms = model.serviceForms && model.serviceForms.length > 0;

    const insType = model.policyInfo.insuranceType.toLowerCase();

    switch (insType) {
        case "af":
            isAnnuity = true;
            break;
        case "ai":
            isFIA = true;
            hasAllocations = model.annuityFIAValues?.allocations;
            break;
        case "hs": //MedSup
            isMS = true;
            break;
        case "spia": //SuppContract
        case "scwlc": //SuppContract
        case "scwolc": //SuppContract
            isSuppConn = true;
            break;
        case "ha":
        case "hc":
        case "hh":
        case "hi":
        case "hx":
            isHealth = true;
            break;
        case "le":
        case "lw":
        case "lt":
            isLife = true;
            break;
        default:
            isUnknown = true;
            break;
    }

    const hasAgents = model.agentInfo;

    const navButton = (id, label, condition = true) =>
        condition && (
            <span
                className={`nav-button ${selectedSection === id ? 'active' : ''}`}
                onClick={() => onNavClick(id)}
            >
                {label}
            </span>
        );

    return (
        <div className="nav-buttons-container">
            <div className="nav-buttons d-md-block buttons-wrapper">
                {navButton('values-container', 'Account Values', isAnnuity || isFIA || isSuppConn)}
                {navButton('values-container', 'Policy Info', isMS || isHealth || isLife)}
                {navButton('owner-container', 'Owner')}
                {navButton('agent-container', 'Agent', hasAgents)}
                {navButton('premium-history-container', 'Premium History', isMS || isHealth || isLife)}
                {navButton('claims-history-container', 'Withdrawal History', !isMS && !isHealth && !isSuppConn)}
                {navButton('claims-history-ms-container', 'Claims History', isMS)}
                {navButton('claims-history-mm-container', 'Claims History', isHealth)}
                {navButton('supp-contract-history-container', 'Supp Contract History', isSuppConn)}
                {navButton('benefits-container', 'Benefits', isHealth)}
                {navButton('id-card-container', 'ID Card', isMS )}
                {navButton('beneficiaries-container', 'Beneficiaries', isAnnuity || isSuppConn)}
                {navButton('allocations-container', 'Allocations', isFIA && hasAllocations)}
                {navButton('correspondence-container', 'Correspondence')}
                {navButton('issue-packet-container', 'Issue Packet', false )}
                {navButton('service-form-container', 'Service Forms', hasServiceForms)}
                {navButton('upload-form-container', 'Upload Forms')}
            </div>
        </div>
    );
};

export default PolicyNav;
